import React, { useEffect, useState } from 'react'
import Image from '@components/image';
import { Link } from 'gatsby';
import { fetchProductFromVariant } from '../helpers';
import { getUriFromDocument } from '@src/utils/routing';

const InstagramPost = ({caption, alternativeCaption, permalink, post, productReference}) => {
  const [product, setProduct] = useState(null);
  
  useEffect(() => {
    fetchProductFromVariant(productReference?.productId).then(product => {
      setProduct(product);
    });
  }, [productReference?.productId]);

  const instaLink = !permalink && product ? getUriFromDocument(product) + "?variantId=" + productReference?.shopifyId : permalink;

  return (
    <div className='mx-[5px] lg:mx-2.5' tabIndex={0}>
      <Link 
        to={instaLink} 
        className='flex flex-col gap-y-5 aspect-[5/6]' 
        target='_blank' 
        tabIndex={0} 
        aria-hidden={false}
        aria-label={product 
          ? `${alternativeCaption || ''}  ${product?.shortTitle} ${productReference?.variantColor?.length > 0 ? `in ${productReference?.color}` : ''}` 
          : `${alternativeCaption || caption || ''}`
        }
        title={product 
          ? `${alternativeCaption || ''}  ${product?.shortTitle} ${productReference?.variantColor?.length > 0 ? `in ${productReference?.color}` : ''}` 
          : `${alternativeCaption || caption || ''}`
        }
      >
        <Image image={post} alt={post?.asset?.altText || post?.asset?.originalFilename?.replace(/\.(.*)$/, '').replace(/[^a-zA-Z0-9]+/g, ' ' )} className={'rounded-xl'} width={320} height={380} />
        {product ? 
          (
            <p className="inline items-baseline gap-1" tabIndex={-1}>
              {alternativeCaption && (
                <>
                  {alternativeCaption}
                  {' '}
                </>
              )}
              <b>{product?.shortTitle}</b>
              {productReference?.variantColor?.length > 0 && (
                <>
                  {' in '}
                  <span 
                    className="rounded-xl inline-block w-3 h-3 relative ml-[2px] mr-1 top-[1px]" 
                    style={{ backgroundColor: productReference?.variantColor?.length > 0 ? productReference?.variantColor[0]?.color?.hex : '' }}>
                  </span>
                  {productReference?.color}
                </>
              )}
            </p>
          ) : (
            <p className='line-clamp-1'>{alternativeCaption || caption || ''}</p>
          )
        }
      </Link>
    </div>
  )
}

export default InstagramPost